import { render, staticRenderFns } from "./brief-footer-page.vue?vue&type=template&id=a7e35502&scoped=true&"
import script from "./brief-footer-page.vue?vue&type=script&lang=js&"
export * from "./brief-footer-page.vue?vue&type=script&lang=js&"
import style0 from "./brief-footer-page.vue?vue&type=style&index=0&id=a7e35502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e35502",
  null
  
)

export default component.exports